import React from 'react';
import clsx from 'clsx';
import { reFetchConfig } from '@/hooks/paging';
import PanelContainer from '@/components/wrappers/PanelContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const TasksPanelContainer = ({
  category,
  children,
  className,
  compact,
}) => {
  const state = Selectors.useTasksPanelContainer({ category });
  const config = compact ? reFetchConfig(state.tasks, state) : undefined;
  Fetch.useFetchRequestTasks({ category }, state.readStatus, config);

  return (
    <PanelContainer canAccess={state.canRead} readErrors={state.readErrors} exists>
      <div className={clsx('aridhia-tasks-panel-container', className)}>
        { children }
      </div>
    </PanelContainer>
  );
};

export default TasksPanelContainer;
